import type { FaireProductEntity } from "../../entity_types/product";

export const p_mkd8y8cb7j: FaireProductEntity = {
  token: "p_mkd8y8cb7j",
  type: "product",
  name: "Sweet Pineapple Tea Towel",
  brandName: "RHB HAWAII",
  imageUrl:
    "https://cdn.faire.com/fastly/b7bc968fea4f2d170debc4b548208be04f252335d7daae6e2df490834eccc02e.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/26bd1bd8a2ba7244a1bdf90c49a52b22f19d8e307d7aec153ef7883f49001e50.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
